import { useEffect, useState } from 'react';
import { applyUpdate, onUpdateReady } from '../offline/updates';

/**
 * Offered, never forced. Applying reloads the page, so a canvasser halfway
 * through a visit sheet decides when -- but they can decide, rather than
 * waiting for the app to be fully closed before a fix reaches them.
 */
export function UpdateBanner() {
  const [ready, setReady] = useState(false);
  const [applying, setApplying] = useState(false);
  const [stalled, setStalled] = useState(false);
  useEffect(() => onUpdateReady(setReady), []);

  // Applying reloads the page, so this component should be gone within a
  // second. If it is still here, the update did not take -- say so instead of
  // spinning forever, which is exactly what the previous version did when the
  // worker had nobody listening for the message.
  useEffect(() => {
    if (!applying) return;
    const timer = window.setTimeout(() => setStalled(true), 6000);
    return () => window.clearTimeout(timer);
  }, [applying]);

  if (!ready) return null;

  return (
    <div className="update-bar" role="status">
      <span>
        {stalled
          ? 'Update did not take. Close the app completely and reopen it.'
          : 'A newer version is ready.'}
      </span>
      {!stalled ? (
        <button
          className="btn btn--small"
          disabled={applying}
          onClick={() => {
            setApplying(true);
            void applyUpdate();
          }}
        >
          {applying ? 'Updating…' : 'Update now'}
        </button>
      ) : null}
    </div>
  );
}
